import { IndividualsDuplexerChannel } from '@wix/ai-scheduling-assistant-common-lib/commonTypes';
import { useDuplexerSubscription } from './use-duplexer-subscription';

// The default ['updated', 'action'] misses a brand-new file's CREATED event (e.g. the first write
// under a pack's `packs/<slug>/` prefix) — mirrors useWorkspaceDuplexer's ENTITY_CHANGE_EVENTS.
const ENTITY_CHANGE_EVENTS: Array<'created' | 'updated' | 'deleted'> = ['created', 'updated', 'deleted'];

/**
 * Fires whenever the user's VFS changes, on the lightweight
 * `individuals-file-system-changed` channel (entityId-only — the caller
 * refetches; the payload carries no entity body). Used by the app view to
 * re-render live as Orion edits an app. HTTPS-only (see useDuplexerSubscription).
 */
export function useFileSystemDuplexer(onChange: () => void) {
  useDuplexerSubscription(IndividualsDuplexerChannel.FILE_SYSTEM_CHANGED, () => onChange(), ENTITY_CHANGE_EVENTS);
}
